import { LoadState } from "../../constants/enums";
import { IUpsellLeadsState } from "./upsellLeads.types";

export const initialUpsellLeadsState: IUpsellLeadsState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  insight: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  recommendedTemplate: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  campaign: {
    loading: LoadState.NotLoaded,
    error: null,
    lastGeneratedCampaignUuid: null,
  },
};
